var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 13 13",
    width: 13,
    height: 13,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "star-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #ffd600 } \n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m5.9 1.3c0.1-0.4 0.7-0.4 0.8 0l1.1 3.3c0.1 0.2 0.2 0.3 0.4 0.3h3.6c0.4 0 0.6 0.5 0.2 0.7l-2.9 2.1c-0.1 0.1-0.2 0.3-0.1 0.4l1.1 3.4c0.1 0.3-0.3 0.7-0.7 0.4l-2.9-2c-0.1-0.1-0.3-0.1-0.5 0l-2.9 2c-0.3 0.3-0.7-0.1-0.6-0.4l1.1-3.4c0.1-0.1 0-0.3-0.1-0.4l-3-2.1c-0.3-0.2-0.1-0.7 0.3-0.7h3.6c0.2 0 0.3-0.1 0.4-0.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.97dec77d81b96195522af1345fa987d9.svg";
export { ForwardRef as ReactComponent };